import { BasicButton } from '@lynx/client-core/src/components'
import { CloseIcon, LinkIcon } from '@lynx/client-core/src/components/Icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import css from './Qr.module.scss'

export interface QrProps {
	url: string
	qr: string
	showQr: boolean
	setShowQr: () => void
}

export const Qr = ({ url, qr, showQr, setShowQr }: QrProps): React.ReactElement | null => {
	const { t } = useTranslation()

	if (!showQr) {
		return null
	}

	return (
		<div className={css['container']}>
			<div className={css['container__content']}>
				<img alt="QR Code" src={qr} onClick={setShowQr} />
				<div className={css['container__buttons']}>
					<BasicButton
						icon={LinkIcon}
						onClick={(): void => {
							navigator.clipboard.writeText(url)
						}}
					>
						{t('pages.litb.copyLink')}
					</BasicButton>
					<BasicButton icon={CloseIcon} onClick={setShowQr}>
						{t('pages.litb.close')}
					</BasicButton>
				</div>
			</div>
		</div>
	)
}
